import React from "react"

export interface LinkText {
    text: string;
    onClick: () => void
}

export const LinkText: React.FC<LinkText> = (props) => {
    return (
        <a className="text-primary underline cursor-pointer" onClick={(e) => props.onClick()}>
            {props.text}
        </a>
    )
}